import { Minimize2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function CompressPDF() {
  const { t } = useLanguage();
  const tk = t.tools.compress;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/compress",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#7c3aed",
    Icon: Minimize2,
    toolKey: "compress",
    showCompressionStats: true,
  };

  return <ToolPage config={config} />;
}
